<template>
    <div class="results-list-tags">
        <button @click="clearFilter"
                class='btn'
                :aria-current="!activeDocTypes || activeDocTypes.length > 1 ? 'page' : 'false'">
            All
        </button>
        <button v-for="type in storyTypes"
                :key="type.id"
                @click="filterByType(type.id)"
                class='btn'
                :aria-current="Array.isArray(activeDocTypes) && activeDocTypes[0] === type.id && activeDocTypes.length === 1 ? 'page' : 'false'">
            {{ type.label }}
        </button>

    </div>
</template>

<script>
    export default {
        name: 'StoriesFilterButtons',

        props: {
            storyTypes: {
                type: Array,
                required: true,
                default: () => [] 
            }
        },
        computed: {
            activeDocTypes() {
                return this.$store.state.search.filters.docTypes
            }
        },
        methods: {
            triggerSearch() {
                this.$eventHub.$emit('search-filtersChanged')
            },

            filterByType(type) {
                this.$store.dispatch('updateSearchFilter', { key: 'docTypes', value: [type] })
                this.triggerSearch()
            },

            clearFilter() {
                const defaultTypes = this.storyTypes.map(type => type.id)
                this.$store.dispatch('updateSearchFilter', { key: 'docTypes', value: defaultTypes })
                this.triggerSearch()
            },
        },

        beforeUnmount() {
            this.$store.dispatch('updateSearchFilter', { key: 'docTypes', value: [] })
        }

    }
</script>
